import React, { useState, useEffect, useRef } from "react";

const ProgressComponent = ({ initialCount = 30, updateCountdown }) => {
  const [countdown, setCountdown] = useState(initialCount);
  const [progressValue, setProgressValue] = useState(100);
  const countdownIntervalRef = useRef(null);

  useEffect(() => {
    countdownIntervalRef.current = setInterval(() => {
      if (document.hasFocus()) {
        setCountdown((prevCountdown) => Math.max(prevCountdown - 1, 0));
      }
    }, 1000);
    return () => clearInterval(countdownIntervalRef.current);
  }, []);

  useEffect(() => {
    if (countdown !== 0) {
      setProgressValue((countdown / initialCount) * 100);
    } else {
      updateCountdown(countdown);
      setProgressValue(100);
      setCountdown(initialCount);
    }
  }, [countdown, initialCount]);

  return (
    <div className="countdown-container">
      <progress
        value={progressValue}
        key={"progressKey"}
        max="100"
        className="custom-progress"
        bgcolor="red"
      ></progress>
    </div>
  );
};

export default ProgressComponent;
